import './App.css';
import RayerTech from './main_page/main_page';

function App() {
  return (
    <div className="App">
      <RayerTech />
    </div>
  );
}

export default App;